module.exports = __webpack_public_path__ + "gas-buddy.png?7b920310f6d2115f4d0fbdc25a7792f1";